import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    trialTitle: translate({ id: 'settings.messagingPlan.view.smsPlan.trialTitle' }),
    trialSubtitle: translate({ id: 'settings.messagingPlan.view.smsPlan.trialSubtitle' }),

    allowOverageTitle: translate({ id: 'settings.messagingPlan.view.smsPlan.allowOverageTitle' }),
    allowOverageSubtitle: 'settings.messagingPlan.view.smsPlan.allowOverageSubtitle',

    dontAllowOverageTitle: translate({
      id: 'settings.messagingPlan.view.smsPlan.dontAllowOverageTitle',
    }),
    dontAllowOverageSubtitle: 'settings.messagingPlan.view.smsPlan.dontAllowOverageSubtitle',
  }))

  return api
}
